module.exports = __webpack_public_path__ + "media/images/coach-c10dfb56777ad35001b1ddd77a45e6b1.jpg";